// extracted by mini-css-extract-plugin
export default {"NoPostsTitle":"PostsContainer_NoPostsTitle__FJVJZ"};